<template>
  <main class="page page--home">
    <main-section/>
    <div v-if="widget && isMounted">
      <WidgetOG :html="widget" />
    </div>
    <div v-if="showBanner" class="main-section__container">
      <img class="home__banner-img" src="/public/img/banner.png" alt=""/>
    </div>
    <news-section/>
    <main-slider />
    <gallery-section/>
    <document-section/>
    <count-section/>
    <link-section/>
  </main>
</template>

<script>
import MainSection from './components/MainSection.vue'
import NewsSection from './components/NewsSection.vue'
import GallerySection from './components/GallerySection.vue'
import CountSection from './components/CountSection.vue'
import DocumentSection from './components/DocumentSection.vue'
import LinkSection from './components/LinkSection.vue'
import WidgetOG from 'components/WidgetOG.vue'
import MainSlider from 'components/MainSlider.vue'

export default {
  async asyncData ({ store }) {
    await store.dispatch('HOME_PAGE')
  },
  name: 'HomePage',
  data () {
    return {
      isMounted: false,
      showBanner: false
    }
  },
  mounted () {
    this.isMounted = true
    if (typeof window !== 'undefined' && typeof location !== 'undefined' && location.host === 'drb.siteuo.ru') {
      this.showBanner = true
    }
  },
  computed: {
    widget () {
      return this.$store.state.department && this.$store.state.department.widgetOG ? this.$store.state.department.widgetOG : null
    }
  },
  components: {
    MainSlider,
    LinkSection,
    DocumentSection,
    CountSection,
    GallerySection,
    NewsSection,
    MainSection,
    WidgetOG
  },
  metaInfo () {
    return this.$store.state.department ? this.$seo(
      'common',
      this.$store.state.department.title,
      'управление образования, образование',
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю',
      this.$store.state.department.title,
      this.$store.state.api + this.$store.state.department.img_head,
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю'
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
